import React from 'react';
import BaseMobileProviderCard from 'parent-portal/providers/cards/BaseMobileProviderCard';
import InternalProviderCardDetails from 'parent-portal/providers/cards/internal/InternalProviderCardDetails';
import GoToProfileAction from 'parent-portal/providers/cards/actions/GoToProfileAction';
import FamilyHiredCaption from './FamilyHiredCaption';
import { IHiredProvider } from '../models';

export default function ProviderHiredCard({ hiredProvider }: { hiredProvider: IHiredProvider }) {
    return (
        <div style={{ width: '370px', margin: '0 10px' }}>
            <FamilyHiredCaption hiredProvider={hiredProvider} />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    height: 280,
                    borderRadius: 18,
                    boxShadow: '0px 3px 6px #00000029',
                }}
            >
                <BaseMobileProviderCard
                    provider={hiredProvider.provider}
                    details={<InternalProviderCardDetails provider={hiredProvider.provider} />}
                    actions={<GoToProfileAction provider={hiredProvider.provider} />}
                />
            </div>
        </div>
    );
}
